import { useTranslation } from 'react-i18next';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { QueryKey } from '@/config/query-client';
import { notify } from '@/ui/snackbar/notify';
import { editMyProfile } from '@/api/v4/user.api';

export const useEditProfile = () => {
  const { t } = useTranslation('default');
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: editMyProfile,
    onError: () => {
      notify({
        message: t('unknownError'),
      });
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: [QueryKey.WhoAmI] });
    },
  });

  return {
    editProfile: mutation.mutateAsync,
    isLoading: mutation.isPending,
  };
};
